import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, ArrowRight } from 'lucide-react';

const events = [
  {
    title: '2nd Annual Africa Climate Finance Conference',
    date: 'April 1-2, 2025',
    location: 'Hotel Africana, Kampala, Uganda',
    time: '9:00 AM - 5:00 PM EAT',
    description: 'Join Africa\'s "Local COP" to discuss closing the climate financing gap and implementing COP29 strategies.',
    featured: true
  },
  {
    title: 'CAFP Program - Next Cohort Information Session',
    date: 'March 20, 2024',
    location: 'Virtual Event',
    time: '2:00 PM - 4:00 PM EAT',
    description: 'Learn about the Climate Adaptation Finance Professional Certificate Program.'
  }
];

export default function EventsCalendar() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900">Featured Events</h2>
        </motion.div>

        <div className="space-y-8">
          {events.map((event, index) => (
            <motion.div
              key={event.title}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`bg-white rounded-xl shadow-lg overflow-hidden ${
                event.featured ? 'border-2 border-green-500' : ''
              }`}
            >
              {event.featured && (
                <div className="bg-green-500 text-white px-4 py-1 text-sm font-medium">
                  Featured Event
                </div>
              )}
              <div className="p-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      {event.title}
                    </h3>
                    <p className="text-gray-600 mb-4">{event.description}</p>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <Calendar className="h-4 w-4 mr-2" />
                        {event.date}
                      </div>
                      <div className="flex items-center">
                        <Clock className="h-4 w-4 mr-2" />
                        {event.time}
                      </div>
                      <div className="flex items-center">
                        <MapPin className="h-4 w-4 mr-2" />
                        {event.location}
                      </div>
                    </div>
                  </div>
                  <button className="mt-4 md:mt-0 inline-flex items-center px-6 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition-colors">
                    Register
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}